import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Cookies from "universal-cookie";
import { logout } from "../../actions";
import styleConstants from "../../shared/constants/styleConstants/styles.json";
import Constants from "../../shared/constants/environmentConfig";
import { getAccountsDomain } from "../../helpers/Utils";
import avatar from "../../shared/images/common/avatar.png";
import dropDownArrow from "../../shared/images/common/drop-down.png";
import "./navbar.css";

const cookies = new Cookies();

class NavBar extends Component {
  constructor(props) {
    super(props);
    this.state = { open: false };
    this.dropDownRef = React.createRef();
    this.handleLogout = this.handleLogout.bind(this);
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  handleLogout() {
    this.props.logout();
  }

  handleClickOutside = (event) => {
    if (
      this.dropDownRef.current &&
      !this.dropDownRef.current.contains(event.target)
    ) {
      this.setState({
        open: false,
      });
    }
  };

  logButton() {
    const {
      auth: { userTypes },
      institute,
    } = this.props;
    const token = cookies.get("token");
    const user = cookies.get("user");
    const color = institute ? "#D56073" : styleConstants.color.primary;
    const dropDownElementStyle = {
      fontSize: "0.8vw",
      fontWeight: "bold",
      color: "#454545 !important",
      borderBottom: "0.5px solid #d5d7db",
    };
    if (token && token !== "") {
      return (
        <div ref={this.dropDownRef} className="dropdown">
          <div
            className="dropbtn"
            onClick={() => this.setState({ open: !this.state.open })}
          >
            <img
              alt=""
              style={{ cursor: "pointer" }}
              src={avatar}
              width="auto"
              height="40px"
            />
            <img
              alt=""
              style={{ cursor: "pointer" }}
              src={dropDownArrow}
              width="auto"
              height="25px"
            />
          </div>
          <div
            className="dropdown-content"
            style={{ display: this.state.open ? "block" : "none" }}
          >
            {user.can_manage_institute && (
              <a
                href={`${Constants().qbankURL}/institute/settings`}
                className="dropdown-item"
                style={dropDownElementStyle}
              >
                Manage my institute
              </a>
            )}
            {userTypes && userTypes.length > 1 && (
              <a
                href={`${Constants().accountsURL}/switch_membership`}
                style={dropDownElementStyle}
              >
                Switch Membership
              </a>
            )}
            <div role="presentation" onClick={this.handleLogout}>
              <a style={dropDownElementStyle}>Logout</a>
            </div>
          </div>
        </div>
      );
    }
    return (
      <div key="navbar-login" className="mr-4">
        <div
          role="presentation"
          className="Button"
          onClick={() =>
            window.location.replace(`${getAccountsDomain()}/sign_in`)
          }
          style={{
            fontWeight: "bold",
            fontSize: 14,
            width: 160,
            backgroundColor: color,
            color: "white",
            height: 40,
            display: "flex",
            placeContent: "center",
            borderRadius: 0,
          }}
        >
          Login
        </div>
      </div>
    );
  }

  render() {
    const user = cookies.get("user");
    const logoUrl = user && user.instituteLogoUrl ? user.instituteLogoUrl : "";
    const { showLogin, isMobile, institute, globalHistory } = this.props;
    return (
      <div
        style={{
          boxShadow: "0 3px 6px 0 rgba(0, 0, 0, 0.08)",
          backgroundColor: "white",
          height: 70,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          position: "fixed",
          width: "100%",
          zIndex: 4,
          top: 0,
        }}
      >
        <div
          style={{
            letterSpacing: 0.5,
            height: "100%",
            width: "16vw",
            marginLeft: isMobile && 20,
            fontWeight: 800,
            backgroundColor: "#132b50",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            role="presentation"
            onClick={
              globalHistory
                ? () => globalHistory.push("/")
                : () => window.location.replace("/")
            }
          >
            <span
              style={{
                color: "#e83242",
                fontSize: 26,
                fontWeight: 800,
                cursor: "pointer",
              }}
            >
              FEE&nbsp;
              <span style={{ color: "white" }}>BOARD</span>
            </span>
          </div>
        </div>
        {logoUrl && (
          <div
            style={{
              marginLeft: 15,
              backgroundColor: "#EDEDED",
              height: 40,
              borderRadius: 3,
            }}
          >
            <div style={{ margin: "7px 24px 7px 24px" }}>
              <img alt="" src={logoUrl} height="24px" />
            </div>
          </div>
        )}
        {isMobile && (
          <div
            role="presentation"
            onClick={this.handleLogout}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: 100,
              height: 40,
              backgroundColor: styleConstants.color.primary,
              borderRadius: 4,
              color: "white",
              marginRight: 20,
            }}
          >
            Logout
          </div>
        )}
        {!isMobile && (
          <>
            {showLogin && (
              <div
                style={{ display: "flex" }}
                id="navbarSupportedContent"
              >
                {this.logButton()}
              </div>
            )}
          </>
        )}
      </div>
    );
  }
}

NavBar.propTypes = {
  institute: PropTypes.object,
  isMobile: PropTypes.bool,
  showLogin: PropTypes.bool,
  auth: PropTypes.object,
};
NavBar.defaultProps = {
  institute: null,
  showLogin: true,
  isMobile: false,
  auth: {},
};

const mapStateToProps = ({ auth }) => ({
  auth,
});

export default connect(mapStateToProps, { logout })(NavBar);
